import { lazy as lazyMfe } from '@signavio/mfe'
import { Feature, prependOrg, useLoggedInSession } from '@signavio/effektif-api'
import { Divider } from '@signavio/ui'
import i18n from '@signavio/i18n'
import { HeaderMenuItemPropsApi as GlobalHeaderMenuItemProps } from 'global-mfe/types/header'

const HeaderMenuItem = lazyMfe<GlobalHeaderMenuItemProps>(
  () => import('GlobalHeader/HeaderMenuItem')
)

export const HelpMenuItems = ({
  onAboutClick,
}: {
  onAboutClick: () => void
}) => {
  const { organization: currentOrganization } = useLoggedInSession()
  return (
    <>
      <Divider />
      {currentOrganization.workflowCreator && (
        <Feature feature="Action.ViewExamples" key="process-example">
          <HeaderMenuItem
            icon="process-example"
            label={i18n('Workflow Templates')}
            href={prependOrg('/processes/examples')}
          />
        </Feature>
      )}
      <HeaderMenuItem
        key="about"
        icon="release-note"
        onClick={() => onAboutClick()}
        label={i18n('About')}
      />
      <HeaderMenuItem
        key="help-support"
        target="_blank"
        href="https://launchpad.support.sap.com/"
        icon="comment"
        label={i18n('Feedback & Support')}
      />
    </>
  )
}
